import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const SustainabilityRoutes: Route = {
    path: 'sustainability',
    data: { title: 'sustainability' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'sustainability-dashboard',
        },
        {
            path: 'dashboard',
            redirectTo: 'sustainability-dashboard',
            pathMatch: 'full',
        },
        {
            path: 'flowmeter-coefficient',
            loadComponent: () =>
                import('./flowmeter-coefficient/flowmeter-coefficient.component').then(
                    (m) => m.FlowmeterCoefficientComponent
                ),
            data: { title: 'flowmeter-coefficient' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'impact-calculation-inputs',
            loadComponent: () =>
                import('./impact-calculation-inputs/impact-calculation-inputs.component').then(
                    (m) => m.ImpactCalculationInputsComponent
                ),
            data: { title: 'impact-calculation-engine-inputs' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'impact-dashboard-kpis',
            loadComponent: () =>
                import('./impact-dashboard-kpis/impact-dashboard-kpis.component').then(
                    (m) => m.ImpactDashboardKpisComponent
                ),
            data: { title: 'impact-dashboard-kpis' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'sustainability-dashboard',
            loadComponent: () =>
                import('./sustainability-dashboard/sustainability-dashboard.component').then(
                    (m) => m.SustainabilityDashboardComponent
                ),
            data: { title: 'sustainability-dashboard-static' },
        },
        {
            path: 'sustainability-dashboard/form',
            loadComponent: () =>
                import(
                    './sustainability-dashboard/sustainability-dashboard-form/sustainability-dashboard-form.component'
                ).then((m) => m.SustainabilityDashboardFormComponent),
            data: { title: 'sustainability-dashboard-static' },
        },
        {
            path: 'sustainability-dashboard/form/:id',
            loadComponent: () =>
                import(
                    './sustainability-dashboard/sustainability-dashboard-form/sustainability-dashboard-form.component'
                ).then((m) => m.SustainabilityDashboardFormComponent),
            data: { title: 'sustainability-dashboard-static' },
        },
    ],
};
